import { React, useState } from "react";
import { AuthWrapper } from "../components/AuthWrapper";
import {
  Box,
  FormControl,
  Input,
  InputGroup,
  InputRightElement,
  Button,
  Divider,
  FormHelperText,
  Center,
  Link,
  Image,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

import http from "../connection/connect";
import { readSession } from "../helpers/global";
import logo from "../assets/animated-right-mark.gif";

const ChangePassword = () => {
  const [isLoading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  //form state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  //password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  //password and confirmPassword visibility functions
  const handleIconClick = () => setShowPassword(!showPassword);
  const handleConfirmIconClick = () =>
    setShowConfirmPassword(!showConfirmPassword);

  //password and confirmPassword match
  var isMatch = password !== confirmPassword;

  //error state
  const [err, setError] = useState("");

  //form values
  const formValues = {
    email,
    password,
  };

  //form submit function
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // "token" was never a key this app writes, so this header was always
      // "Bearer null". The session lives under "userData".
      const response = await http.post("api/auth/change-password", formValues, {
        headers: {
          Authorization: `Bearer ${readSession()?.accessToken ?? ""}`,
        },
      });

      if (response.data.status === 200) {
        setLoading(false);
        setSuccess(true);
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError(error.message);
      }
    }
  };

  return (
    <>
      {
        success
          ? <Box paddingTop="10%">
            <Center>
              <Box boxSize='sm'>
                <Image src={logo} />
              </Box>
            </Center>
            <Center>
              <Box width={'50%'} textAlign={'center'}>
                Password successfully changed you Can login now with your new password
              </Box>
            </Center>
            <Center>
              <Button
                m={3}
                onClick={() => {
                  window.location.href = "https://storkplus.com/";
                }}
              >
                Back to Homepage
              </Button>
            </Center>
          </Box>
          : <AuthWrapper header="Change Password">
            <Divider borderColor="rgba(255, 255, 255, 0.2)" />

            <form onSubmit={handleSubmit}>
              <FormControl pt={4}>
                <FormHelperText color="rgba(255, 255, 255, 0.8)" fontSize="md">
                  Forgotten your password? Enter your e-mail address below, and
                  we'll send you an e-mail allowing you to reset it.
                </FormHelperText>

                <Input
                  mt={5}
                  placeholder="Email"
                  type="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  bg="rgba(255, 255, 255, 0.1)"
                  borderColor="rgba(255, 255, 255, 0.3)"
                  color="white"
                  _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                  _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                  _focus={{
                    borderColor: "rgba(255, 255, 255, 0.8)",
                    bg: "rgba(255, 255, 255, 0.15)",
                    boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                  }}
                />

                <InputGroup mt={5}>
                  <Input
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    bg="rgba(255, 255, 255, 0.1)"
                    borderColor="rgba(255, 255, 255, 0.3)"
                    color="white"
                    _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                    _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                    _focus={{
                      borderColor: "rgba(255, 255, 255, 0.8)",
                      bg: "rgba(255, 255, 255, 0.15)",
                      boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                    }}
                  />
                  <InputRightElement
                    children={
                      showPassword ? (
                        <ViewOffIcon
                          onClick={() => {
                            handleIconClick();
                          }}
                          color="white"
                          cursor="pointer"
                        />
                      ) : (
                        <ViewIcon
                          onClick={() => {
                            handleIconClick();
                          }}
                          color="white"
                          cursor="pointer"
                        />
                      )
                    }
                  />
                </InputGroup>

                <InputGroup mt={5}>
                  <Input
                    placeholder="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                    }}
                    bg="rgba(255, 255, 255, 0.1)"
                    borderColor="rgba(255, 255, 255, 0.3)"
                    color="white"
                    _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                    _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                    _focus={{
                      borderColor: "rgba(255, 255, 255, 0.8)",
                      bg: "rgba(255, 255, 255, 0.15)",
                      boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                    }}
                  />

                  <InputRightElement
                    children={
                      showConfirmPassword ? (
                        <ViewOffIcon
                          onClick={() => {
                            handleConfirmIconClick();
                          }}
                          color="white"
                          cursor="pointer"
                        />
                      ) : (
                        <ViewIcon
                          onClick={() => {
                            handleConfirmIconClick();
                          }}
                          color="white"
                          cursor="pointer"
                        />
                      )
                    }
                  />
                </InputGroup>

                <Box mb={3} color="rgba(252, 165, 165, 1)" fontWeight="500">
                  {isMatch ? "Passwords do not match" : null}
                </Box>

                <Button
                  isLoading={isLoading}
                  colorScheme='blue'
                  loadingText={'Change Password'}
                  type="submit"
                  width="100%"
                  mt={5}
                  height="3.5rem"
                  fontSize="lg"
                  fontWeight="bold"
                  bg="white"
                  color="#001756"
                  _hover={{ bg: "rgba(255, 255, 255, 0.9)" }}
                  _active={{ bg: "rgba(255, 255, 255, 0.8)" }}
                >
                  Change Password
                </Button>

                <Center>
                  {typeof err === "string" && err ? (
                    <Box
                      color="white"
                      mt={3}
                      bg="rgba(220, 38, 38, 0.15)"
                      borderColor="rgba(220, 38, 38, 0.5)"
                      borderWidth="1px"
                      borderRadius="md"
                      p={3}
                    >
                      {err}
                    </Box>
                  ) : (
                    err.length > 0 && (
                      <Box
                        color="white"
                        mt={3}
                        textAlign="center"
                        bg="rgba(220, 38, 38, 0.15)"
                        borderColor="rgba(220, 38, 38, 0.5)"
                        borderWidth="1px"
                        borderRadius="md"
                        p={3}
                      >
                        {err.map((error) => {
                          return <p>{error}</p>;
                        })}
                      </Box>
                    )
                  )}
                </Center>
                <Center mt={3}>
                  <Link href="/login" textAlign="center" color="white" _hover={{ color: "rgba(255, 255, 255, 0.8)", textDecoration: "underline" }}>
                    Have an account? Login
                  </Link>
                </Center>
              </FormControl>
            </form>
          </AuthWrapper>
      }
    </>
  );
};

export default ChangePassword;
